import { STHead } from "@/components";
import { STNewsFeed } from "@/components/STNewsFeed";
import React from "react";

const NewsFeed = () => {
  return (
    <>
      <STHead
        title="News Feed"
        description="Stay updated with the latest news, articles, and insights from Sustanix."
        keywords="Sustanix news, articles, green chemistry, sustainable additives"
        canonicalUrl="https://sustanix.com/news-feed/"
        ogTitle="Catch up on the latest news & blogs from Sustanix"
        ogDescription="Curious about what we are upto at Sustanix, this page has all our updates from lab to events to industry"
        ogKeywords="Sustanix news, articles, green chemistry, sustainable additives"
        ogUrl="https://sustanix.com/news-feed/"
        ogImage="https://sustanix.com/opengraph-image.webp"
        ogType="website"
      />
      <STNewsFeed />
    </>
  );
};

export default NewsFeed;
